export const languages = [
  {
    code: "aa",
    name: "Afar",
  },
  {
    code: "ab",
    name: "Abkhaz",
  },
  {
    code: "ae",
    name: "Avestan",
  },
  {
    code: "af",
    name: "Afrikaans",
  },
  {
    code: "ak",
    name: "Akan",
  },
  {
    code: "am",
    name: "Amharic",
  },
  {
    code: "an",
    name: "Aragonese",
  },
  {
    code: "ar",
    name: "Arabic",
  },
  {
    code: "as",
    name: "Assamese",
  },
  {
    code: "av",
    name: "Avaric",
  },
  {
    code: "ay",
    name: "Aymara",
  },
  {
    code: "az",
    name: "Azerbaijani",
  },
  {
    code: "ba",
    name: "Bashkir",
  },
  {
    code: "be",
    name: "Belarusian",
  },
  {
    code: "bg",
    name: "Bulgarian",
  },
  {
    code: "bh",
    name: "Bihari",
  },
  {
    code: "bi",
    name: "Bislama",
  },
  {
    code: "bm",
    name: "Bambara",
  },
  {
    code: "bn",
    name: "Bengali",
  },
  {
    code: "bo",
    name: "Tibetan",
  },
  {
    code: "br",
    name: "Breton",
  },
  {
    code: "bs",
    name: "Bosnian",
  },
  {
    code: "ca",
    name: "Catalan",
  },
  {
    code: "ce",
    name: "Chechen",
  },
  {
    code: "ch",
    name: "Chamorro",
  },
  {
    code: "co",
    name: "Corsican",
  },
  {
    code: "cr",
    name: "Cree",
  },
  {
    code: "cs",
    name: "Czech",
  },
  {
    code: "cu",
    name: "Church Slavic",
  },
  {
    code: "cv",
    name: "Chuvash",
  },
  {
    code: "cy",
    name: "Welsh",
  },
  {
    code: "da",
    name: "Danish",
  },
  {
    code: "de",
    name: "German",
  },
  {
    code: "dv",
    name: "Divehi",
  },
  {
    code: "dz",
    name: "Dzongkha",
  },
  {
    code: "ee",
    name: "Ewe",
  },
  {
    code: "el",
    name: "Greek",
  },
  {
    code: "en",
    name: "English",
  },
  {
    code: "eo",
    name: "Esperanto",
  },
  {
    code: "es",
    name: "Spanish",
  },
  {
    code: "et",
    name: "Estonian",
  },
  {
    code: "eu",
    name: "Basque",
  },
  {
    code: "fa",
    name: "Persian",
  },
  {
    code: "ff",
    name: "Fula",
  },
  {
    code: "fi",
    name: "Finnish",
  },
  {
    code: "fj",
    name: "Fijian",
  },
  {
    code: "fo",
    name: "Faroese",
  },
  {
    code: "fr",
    name: "French",
  },
  {
    code: "fy",
    name: "Western Frisian",
  },
  {
    code: "ga",
    name: "Irish",
  },
  {
    code: "gd",
    name: "Scottish Gaelic",
  },
  {
    code: "gl",
    name: "Galician",
  },
  {
    code: "gn",
    name: "Guarani",
  },
  {
    code: "gu",
    name: "Gujarati",
  },
  {
    code: "gv",
    name: "Manx",
  },
  {
    code: "ha",
    name: "Hausa",
  },
  {
    code: "he",
    name: "Hebrew",
  },
  {
    code: "hi",
    name: "Hindi",
  },
  {
    code: "ho",
    name: "Hiri Motu",
  },
  {
    code: "hr",
    name: "Croatian",
  },
  {
    code: "ht",
    name: "Haitian",
  },
  {
    code: "hu",
    name: "Hungarian",
  },
  {
    code: "hy",
    name: "Armenian",
  },
  {
    code: "hz",
    name: "Herero",
  },
  {
    code: "ia",
    name: "Interlingua",
  },
  {
    code: "id",
    name: "Indonesian",
  },
  {
    code: "ie",
    name: "Interlingue",
  },
  {
    code: "ig",
    name: "Igbo",
  },
  {
    code: "ii",
    name: "Nuosu",
  },
  {
    code: "ik",
    name: "Inupiaq",
  },
  {
    code: "io",
    name: "Ido",
  },
  {
    code: "is",
    name: "Icelandic",
  },
  {
    code: "it",
    name: "Italian",
  },
  {
    code: "iu",
    name: "Inuktitut",
  },
  {
    code: "ja",
    name: "Japanese",
  },
  {
    code: "jv",
    name: "Javanese",
  },
  {
    code: "ka",
    name: "Georgian",
  },
  {
    code: "kg",
    name: "Kongo",
  },
  {
    code: "ki",
    name: "Kikuyu",
  },
  {
    code: "kj",
    name: "Kwanyama",
  },
  {
    code: "kk",
    name: "Kazakh",
  },
  {
    code: "kl",
    name: "Kalaallisut",
  },
  {
    code: "km",
    name: "Khmer",
  },
  {
    code: "kn",
    name: "Kannada",
  },
  {
    code: "ko",
    name: "Korean",
  },
  {
    code: "kr",
    name: "Kanuri",
  },
  {
    code: "ks",
    name: "Kashmiri",
  },
  {
    code: "ku",
    name: "Kurdish",
  },
  {
    code: "kv",
    name: "Komi",
  },
  {
    code: "kw",
    name: "Cornish",
  },
  {
    code: "ky",
    name: "Kyrgyz",
  },
  {
    code: "la",
    name: "Latin",
  },
  {
    code: "lb",
    name: "Luxembourgish",
  },
  {
    code: "lg",
    name: "Ganda",
  },
  {
    code: "li",
    name: "Limburgan",
  },
  {
    code: "ln",
    name: "Lingala",
  },
  {
    code: "lo",
    name: "Lao",
  },
  {
    code: "lt",
    name: "Lithuanian",
  },
  {
    code: "lu",
    name: "Luba-Katanga",
  },
  {
    code: "lv",
    name: "Latvian",
  },
];
